module.exports = __webpack_public_path__ + "static/media/hall-CSC.db008b36.svg";